import store from "@/services/store";
import moment from 'moment'

function redondeaValue(r, x, operation) {
    var xx = Math.floor(x / r);
    if (xx != x / r) {
        if (operation === 1) {
            xx++;
        }
        xx = xx * r;
        xx = xx - x
    } else {
        if (operation === 1) {
            xx = r;
        } else {
            xx = -r;
        }
    }

    return xx;
}

function aporteValue(porcentaje) {
    if (store.state.crudStore.dataForm.afiliado_nomina.info_nomina.fechaini === null || store.state.crudStore.dataForm.afiliado_nomina.info_nomina.fechafin === null) {
        return store.state.crudStore.dataForm.afiliado_nomina.info_afiliacion.salario * porcentaje
    }
}
export default {
    data() {
        return {
            devengadosItems: [{
                    thead: { th: "concepto" },
                    tbody: { td: ["concepto"] }
                },
                {
                    thead: { th: "valor", style: "width: 100px" },
                    tbody: { td: ["valor"] }
                },
            ],
            devengadosInits: [
                { id: null, concepto: 'Compensación ordinaria', valor: aporteValue(1), predeterminado: aporteValue(1), id_info_nomina: null, },
                { id: null, concepto: 'Auxilio de transporte', valor: 102153, predeterminado: 102153, id_info_nomina: null, }
            ],
            deducidosItems: [{
                    thead: { th: "concepto" },
                    tbody: { td: ["concepto"] }
                },
                {
                    thead: { th: "valor", style: "width: 100px" },
                    tbody: { td: ["valor"] }
                },
            ],
            deducidosInits: [
                { id: null, concepto: 'EPS', valor: aporteValue(0.04), predeterminado: aporteValue(0.04), id_info_nomina: null, },
                { id: null, concepto: 'AFP', valor: aporteValue(0.04), predeterminado: aporteValue(0.04), id_info_nomina: null, }
            ],
            tableGBoptions: {
                modals: [{
                    modal: "Anular",
                    icon: "x-circle",
                    title: "Anular Nómina",
                    variant: 'danger',
                    movil: true
                }, ]
            },

            tableGBSearch: ['info_nomina/name', 'info_nomina/documento'],

            tableGBItems: [{
                    thead: { th: 'Documento' },
                    tbody: { td: ['lis_documento/name', 'info_nomina/documento'] }
                },
                {
                    thead: { th: 'Nombre', sort: null, sortTable: 'info_nomina/name' },
                    tbody: { td: ['info_nomina/name'] }
                },
                {
                    thead: { th: 'Razon Social' },
                    tbody: { td: ['datos_razon/name'], }
                },
                {
                    thead: { th: 'Desde', },
                    tbody: { td: ['info_nomina/fechaini'], }
                },
                {
                    thead: { th: 'Hasta', },
                    tbody: { td: ['info_nomina/fechafin'], }
                },
                {
                    thead: { th: 'Valor', },
                    tbody: { td: ['info_nomina/valor'], }
                },
                {
                    thead: { th: 'Imprimir', },
                    tbody: { td: ['info_nomina/id'], link: '/api/pdf/nomina' }
                },
            ],
        }
    },
}